import React from "react";

import logo from "../assets/img/logo.webp";

/* ===
   FOOTER MENU DATA
=== */

const footerMenus = [
  {
    heading: "Explore ISBMU",
    links: [
      ["About the University", "/about-us"],
      ["Vision & Mission", "/vision-mission"],
      ["Leadership & Management", "/leadership-and-management"],
      ["Accreditations & Recognitions", "/accreditations-recognitions"],
      ["Awards & Achievements", "/awards"],
      ["Contact Us", "/contact-us"],
    ],
  },

  {
    heading: "Admissions",
    links: [
      ["Explore Programmes", "/programmes"],
      ["Admission Procedure", "/admission-procedure"],
      ["Eligibility Criteria", "/eligibility"],
      ["Scholarships", "/scholarships"],
      ["Apply Online", "/apply-online"],
      ["Pay Online", "/pay-online"],
      ["Download Prospectus", "/prospectus"],
    ],
  },

  {
    heading: "Academics & Research",
    links: [
      ["Schools & Faculties", "/schools"],
      ["Academic Calendar", "/academic-calendar"],
      ["Research & Development", "/research"],
      ["Ph.D. Research", "/phd-research"],
      ["IQAC", "/iqac"],
      ["e-Library", "/e-library"],
      ["International Relations", "/international"],
    ],
  },

  {
    heading: "Student Experience",
    links: [
      ["Campus Life", "/campus-life"],
      ["Facilities", "/facilities"],
      ["Hostel", "/hostel"],
      ["Events", "/events"],
      ["Alumni", "/alumni"],
      ["Placements", "/placements"],
      ["Student Login", "/student-login"],
    ],
  },

  {
    heading: "Essential Links",
    links: [
      ["Newsletters", "/newsletters"],
      ["Circulars & Notices", "/notices"],
      ["Anti-Ragging", "/anti-ragging"],
      ["Grievance Redressal", "/grievance-redressal"],
      ["Mandatory Disclosure", "/mandatory-disclosure"],
      ["Public Self Disclosure", "/public-self-disclosure"],
      ["RTI", "/rti"],
      ["Careers", "/careers"],
    ],
  },
];

/* ===
   FOOTER LINK COLUMN
=== */

function FooterLinkColumn({ menu }) {
  return (
    <div>
      {/* COLUMN TITLE */}

      <h3
        className="
          mb-[22px]
          text-[10px]
          font-bold
          uppercase
          tracking-[0.12em]
          text-[#EFC76D]
        "
      >
        {menu.heading}
      </h3>

      {/* LINKS */}

      <ul className="m-0 list-none p-0">
        {menu.links.map(([label, link], index) => (
          <li
            key={label}
            className={index === 0 ? "" : "mt-3"}
          >
            <a
              href={link}
              className="
                group
                flex
                items-center
                justify-between
                gap-[10px]

                text-[11px]
                leading-[1.45]
                text-white/[0.57]

                transition-all
                duration-200

                hover:translate-x-[3px]
                hover:text-white
              "
            >
              <span>{label}</span>

              <span
                className="
                  text-[#EFC76D]
                  opacity-0
                  transition-opacity
                  duration-200

                  group-hover:opacity-100
                "
              >
                ↗
              </span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

/* ===
   FOOTER COMPONENT
=== */

function Footer() {
  return (
    <footer
      className="
        bg-[#041224]
        font-['DM_Sans',sans-serif]
        text-white
      "
    >
      {/* =====
          TOP CTA SECTION
      ===== */}

      <div className="bg-[#8B1E3F] py-[55px]">
        <div
          className="
            mx-auto
            flex
            w-[calc(100%_-_48px)]
            max-w-[1380px]
            items-center
            justify-between
            gap-[50px]

            max-[820px]:block

            max-[620px]:w-[calc(100%_-_24px)]
          "
        >
          {/* CTA TEXT */}

          <div>
            <span
              className="
                text-[13px]
                font-bold
                uppercase
                tracking-[0.16em]
                text-white
              "
            >
              Your future begins here
            </span>

            <h2
              className="
                mt-[9px]
                font-['Libre_Caslon_Display',Georgia,serif]
                text-[clamp(35px,3.8vw,55px)]
                font-normal
                leading-[1.1]
                text-white
              "
            >
              Ready to take the next step?
            </h2>
          </div>

          {/* CTA BUTTON */}

          <div
            className="
              flex
              gap-[9px]

              max-[820px]:mt-7

              max-[620px]:flex-col
            "
          >
            <a
              href="/apply-online"
              className="
                group

                flex
                min-w-[180px]
                items-center
                justify-between
                gap-[25px]

                rounded-full
                border
                border-white

                bg-white

                px-5
                py-[17px]

                text-[13px]
                font-bold
                uppercase
                tracking-[0.08em]
                text-[#071B33]

                transition
                duration-300

                hover:bg-transparent
                hover:text-white

                max-[620px]:w-full
              "
            >
              Apply Online

              <span className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1">
                ↗
              </span>
            </a>
          </div>
        </div>
      </div>

      {/* =====
          MAIN FOOTER
      ===== */}

      <div className="pb-7 pt-[75px]">
        <div
          className="
            mx-auto
            w-[calc(100%_-_48px)]
            max-w-[1380px]

            max-[620px]:w-[calc(100%_-_24px)]
          "
        >
          {/* =
              BRAND + CONTACT
          = */}

          <div
            className="
              grid
              grid-cols-[0.78fr_1.22fr]
              gap-15
              border-b
              border-white/[0.11]
              pb-[50px]

              max-[1100px]:grid-cols-1
              max-[1100px]:gap-10
            "
          >
            {/* BRAND */}

            <div>
              <a
                href="/"
                aria-label="ISBM University"
                className="inline-flex flex-col"
              >
                <img
                  src={logo}
                  alt="ISBM University"
                  className="
                    h-[100px]
                    w-auto
                    rounded-[15px]
                    bg-white
                    p-2
                    object-contain
                  "
                />
              </a>

              <p
                className="
                  mt-[22px]
                  max-w-[440px]
                  text-[13px]
                  leading-[1.75]
                  text-white/[0.52]
                "
              >
                A multidisciplinary learning community committed to knowledge,
                wisdom, humanity and future-ready education.
              </p>
            </div>

            {/* CONTACT GRID */}

            <div
              className="
                grid
                self-center
                grid-cols-3
                gap-[15px]

                max-[820px]:grid-cols-2

                max-[620px]:grid-cols-1
              "
            >
              {/* PHONE */}

              <div>
                <small
                  className="
                    mb-2
                    block
                    text-[14px]
                    font-bold
                    uppercase
                    tracking-[0.12em]
                    text-white/[0.35]
                  "
                >
                  Admissions helpline
                </small>

                <a
                  href="tel:+919373199999"
                  className="
                    text-[18px]
                    leading-[1.5]
                    text-white

                    transition-colors
                    duration-200

                    hover:text-[#EFC76D]
                  "
                >
                  +91-9373199999
                </a>
              </div>

              {/* EMAIL */}

              <div>
                <small
                  className="
                    mb-2
                    block
                    text-[14px]
                    font-bold
                    uppercase
                    tracking-[0.12em]
                    text-white/[0.35]
                  "
                >
                  Email us
                </small>

                <a
                  href="mailto:enquiry@isbmuniversity.edu.in"
                  className="
                    break-words
                    text-[18px]
                    leading-[1.5]
                    text-white

                    transition-colors
                    duration-200

                    hover:text-[#EFC76D]
                  "
                >
                  enquiry@isbmuniversity.edu.in
                </a>
              </div>

              {/* ADDRESS */}

              <div>
                <small
                  className="
                    mb-2
                    block
                    text-[14px]
                    font-bold
                    uppercase
                    tracking-[0.12em]
                    text-white/[0.35]
                  "
                >
                  Visit us
                </small>

                <a
                  href="/contact-us"
                  className="
                    text-[18px]
                    leading-[1.5]
                    text-white

                    transition-colors
                    duration-200

                    hover:text-[#EFC76D]
                  "
                >
                  Raipur, Chhattisgarh, India ↗
                </a>
              </div>
            </div>
          </div>

          {/* =
              FOOTER MENUS
          = */}

          <div
            className="
              grid
              grid-cols-5
              gap-[35px]

              border-b
              border-white/[0.11]

              py-[55px]

              max-[1100px]:grid-cols-3
              max-[1100px]:gap-x-[35px]
              max-[1100px]:gap-y-[45px]

              max-[620px]:grid-cols-2
              max-[620px]:gap-x-[25px]
              max-[620px]:gap-y-[38px]
            "
          >
            {footerMenus.map((menu) => (
              <FooterLinkColumn
                key={menu.heading}
                menu={menu}
              />
            ))}
          </div>

          {/* =
              BOTTOM AREA
          = */}

          <div
            className="
              grid
              grid-cols-[auto_1fr_auto]
              items-center
              gap-[35px]
              pt-7

              max-[820px]:grid-cols-1
              max-[820px]:text-center
            "
          >
            {/* COPYRIGHT */}

            <p
              className="
                m-0
                text-[13px]
                text-white/[0.35]
              "
            >
              © {new Date().getFullYear()} ISBM University. All rights reserved.
            </p>

            {/* LEGAL LINKS */}

            <div
              className="
                flex
                justify-center
                gap-[22px]

                max-[620px]:flex-wrap
              "
            >
              <a
                href="/privacy-policy"
                className="
                  text-[13px]
                  text-white/[0.42]
                  transition-colors
                  hover:text-white
                "
              >
                Privacy Policy
              </a>

              <a
                href="/refund-policy"
                className="
                  text-[13px]
                  text-white/[0.42]
                  transition-colors
                  hover:text-white
                "
              >
                Refund Policy
              </a>

              <a
                href="/terms-and-conditions"
                className="
                  text-[13px]
                  text-white/[0.42]
                  transition-colors
                  hover:text-white
                "
              >
                Terms & Conditions
              </a>

              <a
                href="/sitemap"
                className="
                  text-[13px]
                  text-white/[0.42]
                  transition-colors
                  hover:text-white
                "
              >
                Sitemap
              </a>
            </div>

            {/* SOCIAL MEDIA */}

            <div
              className="
                flex
                justify-end
                gap-[7px]

                max-[820px]:justify-center
              "
            >
              {/* FACEBOOK */}

              <a
                href="#facebook"
                aria-label="Facebook"
                className="
                  grid
                  h-8
                  w-8
                  place-items-center

                  rounded-full
                  border
                  border-white/[0.15]

                  text-[13px]
                  text-white

                  transition-all
                  duration-200

                  hover:border-[#D8AA45]
                  hover:bg-[#D8AA45]
                  hover:text-[#071B33]
                "
              >
                f
              </a>

              {/* INSTAGRAM */}

              <a
                href="#instagram"
                aria-label="Instagram"
                className="
                  grid
                  h-8
                  w-8
                  place-items-center

                  rounded-full
                  border
                  border-white/[0.15]

                  text-[13px]
                  text-white

                  transition-all
                  duration-200

                  hover:border-[#D8AA45]
                  hover:bg-[#D8AA45]
                  hover:text-[#071B33]
                "
              >
                ◎
              </a>

              {/* LINKEDIN */}

              <a
                href="#linkedin"
                aria-label="LinkedIn"
                className="
                  grid
                  h-8
                  w-8
                  place-items-center

                  rounded-full
                  border
                  border-white/[0.15]

                  text-[13px]
                  text-white

                  transition-all
                  duration-200

                  hover:border-[#D8AA45]
                  hover:bg-[#D8AA45]
                  hover:text-[#071B33]
                "
              >
                in
              </a>

              {/* YOUTUBE */}

              <a
                href="#youtube"
                aria-label="YouTube"
                className="
                  grid
                  h-8
                  w-8
                  place-items-center

                  rounded-full
                  border
                  border-white/[0.15]

                  text-[13px]
                  text-white

                  transition-all
                  duration-200

                  hover:border-[#D8AA45]
                  hover:bg-[#D8AA45]
                  hover:text-[#071B33]
                "
              >
                ▶
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;